<template>
  <div class="sales-team-button">
    <FriedH3 v-if="showTitle">{{ $t('dr_meet_our_team') }}</FriedH3>
    <FriedButton
      data-external="dr-sales-team-modal-button"
      button-type="tertiary"
      @click="$emit('show-sales-team-widget')"
    >
      <FriedAvatarGroup :avatars="senderAvatars" size="small" :visible-avatars="3" />
    </FriedButton>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { AvatarHelper } from '../../helpers';
import type { Participant } from '../../types';

const { activeSenders } = defineProps<{
  activeSenders: Participant[];
  showTitle?: boolean;
}>();

const senderAvatars = computed(() =>
  activeSenders.map(sender => ({
    thumbUrl: sender.thumbUrl,
    name: AvatarHelper.getDisplayName(sender),
  }))
);

defineEmits<{
  'show-sales-team-widget': [];
}>();
</script>
